import { render, staticRenderFns } from "./FileSystem.vue?vue&type=template&id=3a1165cb&"
import script from "./FileSystem.vue?vue&type=script&lang=js&"
export * from "./FileSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports